import { render, staticRenderFns } from "./judicial.vue?vue&type=template&id=50f2e4e0&scoped=true"
import script from "./judicial.vue?vue&type=script&lang=js"
export * from "./judicial.vue?vue&type=script&lang=js"
import style0 from "./judicial.vue?vue&type=style&index=0&id=50f2e4e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f2e4e0",
  null
  
)

export default component.exports